import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Eye, EyeOff } from 'lucide-react'


export default function Profile() {
    // const router = useRouter()
    const navigate = useNavigate()
    const [user, setUser] = useState(null)
    console.log("user-------------->", user)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)


    useEffect(() => {
        async function fetchProfile() {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/profile`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("text2sql_authToken")}`,
                    },
                });
                if (res.status === 401) {
                    localStorage.removeItem("text2sql_authToken");
                    localStorage.removeItem("text2sql_user");
                    navigate("/login");
                }
                const data = await res.json();
                if (!res.ok) throw new Error(data.message || 'Not authenticated')
                setUser(data.data)
            } catch (err) {
                setError(err.message)
            } finally {
                setLoading(false)
            }
        }
        fetchProfile()
    }, [])


    // if (loading) return <div className="p-8">Loading...</div>
    // if (error) return (
    //     <div className="p-8">
    //         <p className="mb-4 text-red-600">{error}</p>
    //         <a href="/login" className="text-indigo-600">Sign in</a>
    //     </div>
    // )

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [pwdError, setPwdError] = useState("");
    const [pwdSuccess, setPwdSuccess] = useState("");
    const [isChangingPwd, setIsChangingPwd] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setPwdError("");
        setPwdSuccess("");

        if (newPassword !== confirmPassword) {
            return setPwdError("New passwords do not match.");
        }

        setIsChangingPwd(true);
        try {
            const formData = new FormData();
            formData.append("old_password", oldPassword);
            formData.append("new_password", newPassword);

            const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/change-password`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("text2sql_authToken")}`
                },
                body: formData
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.detail || data.message || "Failed to change password");

            setPwdSuccess("Password changed successfully!");
            setOldPassword("");
            setNewPassword("");
            setConfirmPassword("");
        } catch (err) {
            setPwdError(err.message);
        } finally {
            setIsChangingPwd(false);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("text2sql_authToken");
        localStorage.removeItem("text2sql_user");
        window.location.href = process.env.REACT_APP_BASE_PATH || "/";
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-10">
            <div className="max-w-2xl w-full space-y-6">
                {/* Profile Card */}
                <div className="bg-white p-8 rounded-2xl shadow">
                    <div className="flex items-center gap-6">
                        <div className="w-24 h-24 rounded-full bg-indigo-100 flex items-center justify-center text-3xl font-bold text-indigo-600">
                            {user?.username?.[0]?.toUpperCase() || 'U'}
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold text-gray-900">{user?.username}</h2>
                            <p className="text-gray-600">{user?.email}</p>
                        </div>
                        {/* <div className="ml-auto">
                            <Link to="/profile-update" className="px-4 py-2 rounded-lg bg-indigo-50 text-indigo-700 font-medium hover:bg-indigo-100 transition">
                                Edit Profile
                            </Link>
                        </div> */}
                    </div>

                    <section className="mt-8">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">Account details</h3>
                        <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                            <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                                <dt className="text-sm font-medium text-gray-500">Joined</dt>
                                <dd className="mt-1 text-sm font-semibold text-gray-900">
                                    {new Date(user?.created_at).toLocaleDateString()}
                                </dd>
                            </div>
                            <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                                <dt className="text-sm font-medium text-gray-500">Role</dt>
                                <dd className="mt-1 text-sm font-semibold text-gray-900">
                                    {user?.role || 'User'}
                                </dd>
                            </div>
                        </dl>
                    </section>
                </div>

                {/* Change Password Card */}
                <div className="bg-white p-8 rounded-2xl shadow">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Change Password</h3>

                    {pwdError && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-lg text-sm">{pwdError}</div>}
                    {pwdSuccess && <div className="mb-4 p-3 bg-green-50 text-green-700 rounded-lg text-sm">{pwdSuccess}</div>}

                    <form onSubmit={handleChangePassword} className="space-y-4 max-w-sm">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
                            <div className="relative">
                                <input
                                    type={showOldPassword ? "text" : "password"}
                                    required
                                    value={oldPassword}
                                    onChange={e => setOldPassword(e.target.value)}
                                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 pr-10"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowOldPassword(!showOldPassword)}
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                >
                                    {showOldPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                            <div className="relative">
                                <input
                                    type={showNewPassword ? "text" : "password"}
                                    required
                                    value={newPassword}
                                    onChange={e => setNewPassword(e.target.value)}
                                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                                    title="Password must be at least 8 characters long, include at least one uppercase letter, one lowercase letter, one number, and one special character (e.g. Test@123)."
                                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 pr-10"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                >
                                    {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
                            <div className="relative">
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    required
                                    value={confirmPassword}
                                    onChange={e => setConfirmPassword(e.target.value)}
                                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 pr-10"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                >
                                    {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                        </div>
                        <button
                            type="submit"
                            disabled={isChangingPwd}
                            className="w-full py-2.5 px-4 bg-gray-900 hover:bg-gray-800 text-white font-medium rounded-lg transition disabled:opacity-50"
                        >
                            {isChangingPwd ? "Updating..." : "Update Password"}
                        </button>
                    </form>
                </div>

                {/* Actions */}
                <div className="flex justify-end">
                    <button
                        className="px-6 py-2.5 rounded-lg bg-red-50 text-red-700 font-medium hover:bg-red-100 transition"
                        onClick={handleLogout}
                    >
                        Sign out
                    </button>
                </div>
            </div>
        </div>
    )
}